<template>
  <BaseButton
    class="tw:px-0!"
    :class="{
      'tw:text-xs!': fontSize === 'xs',
      'tw:text-md!': fontSize === 'md',
    }"
    data-testid="full-broadcast-anchor"
    dense
    icon="full-article"
    icon-size="md"
    :label="getLocaleText('broadcast_mention_card.view_broadcast')"
    new-design
    new-icon
    @click="viewFullBroadcast"
  />
</template>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import { BaseButton } from "shared/components/base";
import useMention from "shared/composables/useMention";
import type { RadioClip, TvCaption } from "shared/types/mentions";
import { isKinetiqMention } from "shared/types/mentions/guards";

const props = defineProps<{
  fontSize: "xs" | "md";
  mention: TvCaption | RadioClip;
}>();

const { openModalForTvEyesMention, viewMentionDetail } = useMention();

function viewFullBroadcast() {
  if (isKinetiqMention(props.mention)) {
    viewMentionDetail(props.mention, true);

    return;
  }

  openModalForTvEyesMention(props.mention, {
    forceFullBroadcast: true,
    trackTvEyesMediaRequestStatus: true,
  });
}
</script>
